import { useEffect, useState } from "react";
import { useGetNotificationsCountMutation } from "services/notification/notification.endpoint";

export const useNotificationVM = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);

    const [getNotificationsCount, getNotificationsCountResult] = useGetNotificationsCountMutation();

    useEffect(() => {
        getNotificationsCount(undefined);
    }, [getNotificationsCount]);

    useEffect(() => {
        if (!getNotificationsCountResult) return;
        if (getNotificationsCountResult.isLoading) return;
        if (getNotificationsCountResult.isError) return;
        if (getNotificationsCountResult.isSuccess) {
            setUnreadCount(getNotificationsCountResult.data.data);
        }
    }, [getNotificationsCountResult]);

    return {
        unreadCount,
        isOpen,
        setUnreadCount,
        setIsOpen
    };
};
